import { DocumentListCard } from '@yes.technology/react-toolkit'

import Activity from './Activity'
import EditStep from './EditStep/EditStep'
import styled from 'styled-components'
import { FlatInteractionModelItemGroup } from 'types/shared'
import { useReviewContext } from '../context'

interface ItemProps {
  children: React.ReactNode
}

export const Item = styled.div<ItemProps>`
  position: relative;

  h2 {
    width: calc(100% - 32px);
  }
`

interface ItemGroupProps {
  itemGroups: FlatInteractionModelItemGroup[]
  goToStep?: (step: number) => void
}

const notDisplayedTypes = ['safe_html', 'interaction_review']

const ItemGroup = ({ itemGroups, goToStep }: ItemGroupProps) => {
  const { flatData, reviewActivity, displayedActivityModels } =
    useReviewContext()
  const activityModels = flatData?.activity_models || {}

  return (
    <>
      {itemGroups &&
        itemGroups.map((itemGroup, i) => {
          const step = i + 1

          let activityModelIds = itemGroup.activity_models.filter(
            (activityModelId) =>
              !notDisplayedTypes.includes(
                activityModels[activityModelId]?.content_type
              )
          )

          if (displayedActivityModels?.length) {
            activityModelIds = activityModelIds.filter((activityModelId) =>
              displayedActivityModels.includes(activityModelId)
            )
          }

          return activityModelIds.length ? (
            <Item key={itemGroup.uuid}>
              <DocumentListCard className='mt-2'>
                {!reviewActivity && (
                  <EditStep onClick={() => goToStep?.(step)} />
                )}
                <h2>{itemGroup.des}</h2>
                <div className='card-body'>
                  {itemGroup.complement && <p>{itemGroup.complement}</p>}

                  <Activity activityModelIds={activityModelIds} />
                </div>
              </DocumentListCard>
            </Item>
          ) : null
        })}
    </>
  )
}

export default ItemGroup
